
import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { cpf, cnpj } from 'cpf-cnpj-validator'; 

export function cpfOrCnpj(): ValidatorFn {

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control?.value?.replace(/[^0-9]/g, "");

    if(!value || value?.length == 0){
      return null;
    } else if(value?.length == 11 && cpf.isValid(value)){
        return null;
    } else if(value?.length == 14 && cnpj.isValid(value)) {
        return null;
    } else {
        return { 'cpfOrCnpj': true };
    }
  };
}
// Validators.email aceita "a@b" (sem domínio), que depois quebra o envio do orçamento por e-mail
const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function emailAddress(): ValidatorFn {

  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control?.value ?? '').toString().trim();

    if (!value) {
      return null;
    }
    return EMAIL_REGEX.test(value) ? null : { 'email': true };
  };
}
